/**
 * Kulüp bültenleri — CMS yoksa i18n: `bulletinsPage.fallbackItems`.
 * @typedef {{
 *   id: string,
 *   title: string,
 *   createdAt: string,
 *   coverImageSrc: string,
 *   pdfUrl: string,
 * }} Bulletin
 */

/**
 * @param {unknown} raw
 * @returns {Bulletin[]}
 */
export function mapBulletinsFallbackFromI18n(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
        .filter((x) => x && typeof x === 'object')
        .map((x) => {
            const o = /** @type {Record<string, unknown>} */ (x);
            return {
                id: String(o.id ?? ''),
                title: String(o.title ?? ''),
                createdAt: String(o.createdAt ?? ''),
                coverImageSrc: String(o.coverImageSrc ?? ''),
                pdfUrl: String(o.pdfUrl ?? ''),
            };
        })
        .filter((b) => b.id && b.title && b.pdfUrl);
}
